import type { ApiConfig } from '../../types'

export const withdrawalHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 500,
  order: 'desc',
  range: (30 * 24 * 60 * 60 - 1) * 1000, // 30 days in milliseconds
  requiresRange: true,
  type: 'withdrawal-history',
} as const satisfies ApiConfig
